import { NgModule } from '@angular/core';

import { SparkShellModule } from '@shared/components/shell/shell.module';

import { AuthenticatedRoutingModule } from './authenticated-routing.module';
import { AuthenticatedComponent } from './authenticated.component';

@NgModule({
  declarations: [AuthenticatedComponent],
  imports: [SparkShellModule, AuthenticatedRoutingModule],
  exports: [AuthenticatedComponent]
})
export class AuthenticatedModule {}
